module.exports = __webpack_public_path__ + "img/colorful-v3-on.247d73c7.png";